import { Link } from "react-router-dom";
import { Heart, X } from "lucide-react";
import { useShop } from "../contexts/ShopContext";
import { formatPrice } from "../lib/format";

export default function Wishlist() {
  const { wishlist, toggleWishlist, addToCart } = useShop();

  return (
    <div className="pt-32 pb-24 px-6 md:px-12 min-h-screen">
      <p className="text-xs uppercase tracking-[0.3em] text-gold mb-3">Your Selection</p>
      <h1 className="font-serif text-5xl md:text-6xl mb-12">Wishlist</h1>

      {wishlist.length === 0 ? (
        <div className="py-24 text-center space-y-5">
          <Heart size={36} strokeWidth={1} className="mx-auto text-muted" />
          <p className="font-serif text-2xl">Nothing saved yet</p>
          <p className="text-muted text-sm max-w-md mx-auto">Mark pieces you love and they'll appear here for considered review.</p>
          <Link to="/shop" className="btn-outline inline-block mt-4">Explore Collection</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
          {wishlist.map(p => (
            <div key={p.product_id} className="group" data-testid={`wishlist-item-${p.product_id}`}>
              <Link to={`/product/${p.product_id}`} className="block aspect-[3/4] overflow-hidden bg-[#141414] relative">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <button
                  onClick={(e) => { e.preventDefault(); toggleWishlist(p); }}
                  className="absolute top-3 right-3 p-2 bg-black/40 backdrop-blur-sm text-text hover:text-gold"
                  data-testid={`remove-wishlist-${p.product_id}`}
                ><X size={16} strokeWidth={1.5} /></button>
              </Link>
              <div className="mt-4 flex justify-between items-start">
                <div>
                  <h3 className="font-serif text-lg">{p.name}</h3>
                  <p className="text-sm text-gold mt-1">{formatPrice(p.price)}</p>
                </div>
                <Link to={`/product/${p.product_id}`} className="nav-link">View →</Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
